import { transliterate } from './transliterate';

export function filterBySearch(items, searchText, getFields) {
  const lowerSearch = searchText.toLowerCase();
  const translitSearch = transliterate(lowerSearch);

  return items.filter(item => {
    const fields = getFields(item);
    return fields.some(f =>
      f.toLowerCase().includes(lowerSearch) || f.toLowerCase().includes(translitSearch)
    );
  });
}

export function highlightText(text, searchText, TextComponent) {
  if (!searchText) return text;

  const lowerSearch = searchText.toLowerCase();
  const translitSearch = transliterate(lowerSearch);
  const regex = new RegExp(`(${searchText}|${translitSearch})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, idx) =>
    part.toLowerCase() === lowerSearch || part.toLowerCase() === translitSearch
      ? <TextComponent mark key={idx}>{part}</TextComponent>
      : part
  );
}
